<template>
  <div class="testimonials" v-if="randomTestimonial">
    <div class="inner">
      <div class="heading">Testimonials</div>
      <div class="quote">
        <p>"{{ randomTestimonial.quote }}"</p>
        <p>{{ randomTestimonial.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  data: function () {
    return {}
  },
  computed: {
    ...mapState(["page"]),
    randomTestimonial() {
      if (!this.page) return null
      if (!this.page.testimonials) return null
      if (!this.page.testimonials.length) return null

      return this.page.testimonials[Math.floor(Math.random() * this.page.testimonials.length)]
    }
  }
}
</script>

<style scoped>
.testimonials {
  padding: 8rem 0;
  padding-top: 8rem;
  font-size: 2rem;
}
.quote p:last-child {
  padding-top: 2rem;
  opacity: 0.6;
}
@media screen and (max-width: 650px) {
  .heading {
    font-size: 3rem;
  }
}
</style>
